/**
 * Expands a relay path into a websocket URL on the page's own origin, which keeps the
 * browser away from the internal backend hostnames it is not allowed to reach.
 */
export function buildSameOriginGraftUrl(path: string): string | undefined {
  if (typeof window === 'undefined') {
    return undefined
  }

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'

  return `${protocol}//${window.location.host}${path}`
}
